import { render, staticRenderFns } from "./merchant.vue?vue&type=template&id=0204d03e&scoped=true&"
import script from "./merchant.vue?vue&type=script&lang=ts&"
export * from "./merchant.vue?vue&type=script&lang=ts&"
import style0 from "./merchant.vue?vue&type=style&index=0&id=0204d03e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0204d03e",
  null
  
)

export default component.exports